module.exports = __webpack_public_path__ + "ea3460734c5da13e7b31b9f25898ab3b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/Singh.png
// module id = 0TKG
// module chunks = 0